var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7163 17.0875C10.8513 17.9799 10.0168 18.7113 9.39887 19.2196C8.59304 19.8824 7.40703 19.8824 6.60122 19.2195C5.98331 18.7113 5.14887 17.9799 4.2839 17.0875C2.58306 15.3328 0.646124 12.8374 0.152685 10.1107C-0.845435 4.59527 3.19662 0.283203 8.00003 0.283203C12.8035 0.283203 16.8452 4.5953 15.8474 10.1107C15.3541 12.8374 13.4171 15.3328 11.7163 17.0875ZM8 12.2832C10.2091 12.2832 12 10.4923 12 8.2832C12 6.07406 10.2091 4.2832 8 4.2832C5.79086 4.2832 4 6.07406 4 8.2832C4 10.4923 5.79086 12.2832 8 12.2832Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdress);
export default __webpack_public_path__ + "static/media/adress.4a9556fca665314ef3b5c63663ce55d7.svg";
export { ForwardRef as ReactComponent };